import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleData } from 'Pages/vehicles/helpers/vehicle.schema';

export const useServiceHistory = (): VehicleData['serviceHistory'] & { hasManualStampsCount: boolean; id: number } => {
	const { id, serviceHistory } = useVehicleData();
	const { independentServiceStampsCount, officialServiceStampsCount } = serviceHistory;
	const hasManualStampsCount = !!independentServiceStampsCount || !!officialServiceStampsCount;

	return { ...serviceHistory, hasManualStampsCount, id };
};
